import { Injectable } from '@angular/core';
import { WalkaroundQuestion } from '../models/walkaround-question.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WalkaroundQuestionService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getWalkaroundQuestionById(id: number): Observable<WalkaroundQuestion> {

    if(id <= 0 || id === null || id === undefined) {
      throw new Error('WalkaroundQuestionService: Id must be a valid number');
    }

    return this.httpClient.get(this._endpoint + 'driver-checks/' + id).pipe(map((value: any) => {
      return <WalkaroundQuestion>value;
    }));
  }

  createWalkaroundQuestion(question: WalkaroundQuestion): Observable<WalkaroundQuestion> {

    if(!question) {
      throw new Error('walkaround question service: you must supply a question object for saving');
    }

    delete question.createdAt;
    delete question.updatedAt;

    if(question.id > 0) {
      throw new Error('walkaround question service: Cannot create an existing object');
    }

    delete question.id;
    return this.httpClient.post(this._endpoint + 'driver-checks',
    JSON.stringify(question),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <WalkaroundQuestion>data;
    }));
  }

  updateWalkaroundQuestion(question: WalkaroundQuestion): Observable<WalkaroundQuestion> {

    if(!question) {
      throw new Error('walkaround question service: you must supply a question object for saving');
    }

    delete question.createdAt;
    delete question.updatedAt;

    if(!question.id || question.id === -1) {
      throw new Error('walkaround question service: Cannot update a record without id');
    }

    return this.httpClient.put(this._endpoint + 'driver-checks/' + question.id,
    JSON.stringify(question),
    {headers: {'Content-Type': 'application/json'}}).pipe(map((data) => {
      return <WalkaroundQuestion>data;
    }));
  }
}
